import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  CssBaseline,
  TextField,
  Button,
  Grid,
  Typography,
  CircularProgress,
  Checkbox, 
  FormControlLabel,
  Link,
  Divider,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { logout, signInWithGoogle, signUpWithEmail, hasUserVerifedEmail, resendVerifedEmail, getGeoData} from "../../common/Authenticator";
import appLogo from "../../images/website-images/logos/app-logo.png";
import closeIcon from "../../images/website-images/icons/close-icon.png"; 
import googleIcon from "../../images/website-images/icons/google-icon.png";
import { useLocation } from "react-router-dom";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [termsOfServiceChecked, setTermsOfServiceChecked] = useState(false);
  
  const [marketingOptInChecked, setMarketingOptInChecked] = useState(false);
  const [marketingOptInAgreementLabel,setMarketingOptInAgreementLabel] = useState("I agree to receive marketing communications and understand I can unsubscribe at any time.");

  const [openTermsDialog, setOpenTermsDialog] = useState(false);

  const [openAcountHasEmailPasswordLoginDialog, setOpenAcountHasEmailPasswordLoginDialog] = useState(false);

  const [showSignUpForm, setShowSignUpForm] = useState(true);
  const [showVerificationEmailSentMessage, setShowVerificationEmailSentMessage] = useState(false);
  const [showEmailNotYetVerifiedMessage, setShowEmailNotYetVerifiedMessage] = useState(false);
  const [openAcountAlreadyExistsDialog, setOpenAcountAlreadyExistsDialog] = useState(false);
  const [openEmailAddressNotYetVerifiedDialog, setEmailAddressNotYetVerifiedDialog] = useState(false);
  const [openEmailResentDialog, setOpenEmailResentDialog] = useState(false);

  const [sourcePage, setSourcePage] = useState(false);

  const [country, setCountry] = useState("");

  const navigate = useNavigate();

  const location = useLocation();

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const action = params.get("action");
  const sourcepage = params.get("sourcepage");

  setSourcePage(sourcepage);

  if (action === "email-verification-required") {
    setShowEmailNotYetVerifiedMessage(true);
    setEmailAddressNotYetVerifiedDialog(true);

    setShowSignUpForm(false);
    setShowVerificationEmailSentMessage(false);
    setOpenAcountAlreadyExistsDialog(false);
  }

  const name = params.get("name");
  const email = params.get("email");

  if (name)
  {
    setName(name);
  }

  if (email)
  {
    setEmail(email);
  }


     // Define an async function inside useEffect
    const fetchGeoData = async () => {
      try {
        const geoData = await getGeoData();
        setCountry(geoData.country);
      } catch (error) {
        console.error("Failed to fetch geo data:", error);
        // Handle errors if necessary
      }
    };

    // Call the async function
    fetchGeoData();

    if (window.fbq)
    {
      window.fbq('track', 'ViewContent', {
        app: "Bakeryly".toLowerCase()
      });
    }


}, [location.search]);

  const handleTermsOfServiceChange = (event) => {
    setTermsOfServiceChecked(event.target.checked);
  };

  const handleSignOutAndLogin = async () => {
    await logout();
    navigate("/login");
  };

  const handleCloseTermsDialog = () => {
    setOpenTermsDialog(false);
  };

  const handleCloseAcountAlreadyExistsDialog = () => {
    setOpenAcountAlreadyExistsDialog(false);
  };

  const handleCloseEmailAddressNotYetVerifiedDialog = () => {
    setEmailAddressNotYetVerifiedDialog(false);
  };

  
  const handleCloseEmailResentDialog = () => {
    setOpenEmailResentDialog(false);
  };

  const handleGoogleSignIn = async () => {
  /*
    if (!termsOfServiceChecked) {
      setOpenTermsDialog(true);
      return;
    }
    */

    setGoogleLoading(true);

    try
    {
        localStorage.setItem("testMode", "true");
        const signInResult =await signInWithGoogle(marketingOptInChecked,marketingOptInAgreementLabel);

          if (signInResult.status === "already-has-password-login")
          {
            
            setOpenAcountHasEmailPasswordLoginDialog(true);

          } else 
          {
            // ✅ GA4 event - //Sending event for retargeting
            if (sourcePage === "demo" && window.gtag) {
              window.gtag('event', 'signup_complete', {
                app: "Bakeryly".toLowerCase()
              });
            }

            // Meta event - Sending event for retargeting
            if (sourcePage === "demo" && window.fbq) {
                
                window.fbq('track', 'CompleteRegistration', {
                  app: "Bakeryly".toLowerCase()
                });

                window.fbq('trackCustom', 'SwgSignupComplete', {
                  app: "Bakeryly".toLowerCase()
                });

            }

              navigate("/app");
          }
    } catch (error) {
      console.error("Signup Error:", error);
    } finally {
      setGoogleLoading(false);
    }

  };

  const handleEmailSignup = async (e) => {
    e.preventDefault();

    /*
    if (!termsOfServiceChecked) {
      setOpenTermsDialog(true);
      return;
    }
    */

    setLoading(true);
    try {
      localStorage.setItem("testMode", "true");
      
      const result = await signUpWithEmail(email, password, name, marketingOptInChecked,marketingOptInAgreementLabel);

      if (result.status === "verification-email-sent")
      {
          setShowSignUpForm(false);
          setShowVerificationEmailSentMessage(true);

          setShowEmailNotYetVerifiedMessage(false);
          setOpenAcountAlreadyExistsDialog(false);
          setEmailAddressNotYetVerifiedDialog(false);

      } else if (result.status === "account-already-exists")
      {

        setOpenAcountAlreadyExistsDialog(true);
      }

      // ✅ GA4 event - Sending event for retargeting
      if (sourcePage === "demo" && window.gtag) {
        window.gtag('event', 'signup_complete', {
          app: "Bakeryly".toLowerCase()
        });
      }

      // Meta event - Sending event for retargeting
      if (sourcePage === "demo" && window.fbq) {
      
        window.fbq('track', 'CompleteRegistration', {
          app: "Bakeryly".toLowerCase()
        });

        window.fbq('trackCustom', 'SwgSignupComplete', {
          app: "Bakeryly".toLowerCase()
        });

      }

      //navigate("/app"); //IMPORTANT: LEAVE COMMENTED- We signing up with email the verification email sent dialog will always popup first
    
    } catch (error) {
      console.error("Signup Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleResendVerificationEmail = async (e) => 
  {
   
    const emailAlreadyVerified = await resendVerifedEmail(email,password);
      if (emailAlreadyVerified)
      {
        navigate("/app");

      } else
      {
        setShowSignUpForm(false);
        setShowVerificationEmailSentMessage(true);

        setShowEmailNotYetVerifiedMessage(false);
        setOpenAcountAlreadyExistsDialog(false);
        setEmailAddressNotYetVerifiedDialog(false);

        setOpenEmailResentDialog(true);
      }
  };

  const handleCheckEmailHasBeenVerified = async (e) => 
  {
      const emailVerified = await hasUserVerifedEmail(email,password);
      if (emailVerified)
      {
        navigate("/app");

      } else
      {
        setShowEmailNotYetVerifiedMessage(true);
        setEmailAddressNotYetVerifiedDialog(true);

        setShowSignUpForm(false);
        setShowVerificationEmailSentMessage(false);
        setOpenAcountAlreadyExistsDialog(false);
        
        
      }

  } 



  return (

    <Container component="main" maxWidth="xs" sx={{ display: 'flex', justifyContent: 'center', marginTop:'40px' }}>
      
      <CssBaseline />

      <Box
        sx={{
          border: "1px solid #e0e0e0", // light gray border
          borderRadius: "12px",
          boxShadow: "3px 3px 12px #bfbfbf", // soft shadow
          paddingTop: 4,
          paddingBottom: 4,
          paddingLeft: { xs: 4, sm: 8 },
          paddingRight: { xs: 4, sm: 8 },
          backgroundColor: "#fff", // white background
          minWidth: { sm: '550px' }, // Only applies from 'sm' (600px) and up
        }}
      >
        <Box
          position="absolute"
          top={10}
          right={10}
          zIndex={10}
        >
          <a href={sourcePage === "demo" ? "/demo" : "/"}>
            <img src={closeIcon} style={{ height: "30px" }} alt="close" />
          </a>
        </Box>
      

          <Box textAlign="center" pb={1}>
            <img
              src={appLogo}
              alt="App Logo"
              style={{ height: 85, cursor: "pointer" }}
              onClick={() => navigate(sourcePage === "demo" ? "/demo" : "/")}
            />

              {sourcePage === "demo" ? (
              
              <Box textAlign="left" pb={1}>
                  
                  <Typography textAlign="center" component="h1" variant="h6" fontWeight="600" mt={2}>
                  Start with the same setup you just saw
                </Typography>
                  <ul>
                    <li>This is the same setup you just saw in the walkthrough.</li>
                    <li>It takes about 2 minutes to get started.</li>
                    <li>No credit card required.</li>
                    <li>If it’s not useful, you can delete it.</li>
                  </ul>
                <Typography textAlign="center">
                  You’re not signing up for marketing emails or a sales call.
                </Typography>
                  

              </Box>

            ) : (
              <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
                Create your Bakeryly account
              </Typography>
            )}

          </Box>

          {showSignUpForm && 
          <Box>
                {/* TERMS OF SERVICE CHECKBOX 
                <Box sx={{textAlign:'center'}}>
                <FormControlLabel
                    control={
                      <Checkbox
                        checked={termsOfServiceChecked}
                        onChange={handleTermsOfServiceChange}
                        name="terms"
                        color="primary"
                      />
                    }
                    label={
                      <Typography fontSize="18px" color="#000000">
                        I agree to the{' '}
                        <Link href="/terms-of-service" target="_blank">
                          Terms of Service
                        </Link>.
                      </Typography>
                    }
                  />
                  </Box>
              END TERMS OF SERVICE CHECKBOX */}

              {(loading || googleLoading) && (      
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#5C6AC4",
                  fontSize: "16px",
                  fontWeight: 600,
                  marginBottom: "2px"
                }}
              >    
                  Hang tight! We’re getting everything ready for you—it’ll just take a minute
              </Typography>

              )}

              {country !== "US" &&
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={marketingOptInChecked}
                      onChange={(e) => setMarketingOptInChecked(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={marketingOptInAgreementLabel}
                />
                 <Box sx={{textAlign:'center'}}>
                  
                          <Typography fontSize="12px" color="#000000">
                            <Link href="/privacy.html" target="_blank">
                              Privacy Policy
                            </Link>
                          </Typography>
                  
                  </Box>
              </Grid>
              }

              <Button
                fullWidth
                variant="outlined"
                onClick={handleGoogleSignIn}
                sx={{
                  mt: 2,
                  mb: 2,
                  textTransform: "none",
                  fontWeight: "bold",
                  minHeight: '55px',
                  fontSize:'17px'
                }}
                disabled={loading || googleLoading}
              >
                <img
                  src={googleIcon}
                  alt="Google Icon"
                  style={{ width: 20, marginRight: 10 }}
                />                
                {googleLoading ? (<CircularProgress size={24} color="inherit" />) : sourcePage === "demo" ? ("Start with Google") : ("Sign up with Google")}

              </Button>
              
              <Box display="flex" alignItems="center" mb={2}>
                <Divider sx={{ flex: 1 }} />
                <Typography sx={{ mx: 2, color: "text.secondary" }}>OR</Typography>
                <Divider sx={{ flex: 1 }} />
              </Box>

              <form onSubmit={handleEmailSignup}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      fullWidth
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      error={!!errors.email}
                      helperText={errors.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Full name"
                      fullWidth
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      error={!!errors.name}
                      helperText={errors.name}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Password"
                      type="password"
                      fullWidth
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      error={!!errors.password}
                      helperText={errors.password}
                    />
                  </Grid>

                </Grid>
                
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    backgroundColor: "#635bff",
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "18px",
                  }}
                  disabled={loading || googleLoading}
                >
                  {loading ? (<CircularProgress size={24} color="inherit" />) : sourcePage === "demo" ? ("Start my setup") : ("Create account")}
                </Button>
              </form>

              <br></br>    
              <Box sx={{textAlign:'center', fontWeight:'bold', paddingTop:'10px'}}>
                No Credit Card Required
              </Box>
              
              <Box sx={{textAlign:'center', fontWeight:'bold', paddingTop:'10px'}}>
              7-day free trial
              </Box>

              <Box textAlign="center" mt={3}>
                <Typography variant="body2" sx={{fontSize:'18px'}}>
                  Already have an account?{" "}
                  <a href="/login" style={{ fontWeight: "bold", color: "#5f5fff" }}>
                    Sign in
                  </a>
                </Typography>

                  {/* TERMS OF SERVICE CHECKBOX */}
                  <br></br>
                <Box sx={{textAlign:'center'}}>
                  
                          <Typography fontSize="16px" color="#000000">
                            <Link href="/terms-of-service" target="_blank">
                              Terms of Service
                            </Link>
                          </Typography>
                  
                  </Box>
                {/* END TERMS OF SERVICE CHECKBOX */}
              </Box>
        </Box>
      } {/* End regular form */}

      {showVerificationEmailSentMessage && 

        <Box>
          <Box
          sx={{
            mt: 4,
            p: 3,
            border: '1px solid #ccc',
            borderRadius: '8px',
            textAlign: 'center',
            backgroundColor: '#f9f9f9',
          }}
          >
              <Typography variant="h6" gutterBottom>
                Verification Email Sent
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                We've sent a verification email to your inbox. Please check your email and confirm your email address. Once you've verified it, you can click the button below to proceed to the application.
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
              If you haven’t received the email within 5 minutes, you can&nbsp;
              <Link href="#" onClick={handleResendVerificationEmail}>
                click here to resend it
              </Link>. Also, be sure to check your spam or junk folder just in case it ended up there.
            </Typography>

            <Typography variant="h7">
              <b>I'VE VERIFIED MY EMAIL</b>
            </Typography>

            <Box
          sx={{paddingTop:'5px', textAlign:'center' }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleCheckEmailHasBeenVerified}
            >
              Continue to Application
            </Button>
          </Box>
          </Box>

          <Box
          sx={{
            mt: 4,
            p: 3,
            borderRadius: '8px',
            textAlign: 'center',
          }}
          >
          <Button
              variant="outlined"
              onClick={handleSignOutAndLogin}
              sx={{ textTransform: 'none' }}
            >
              Sign in as a different user
            </Button>
          </Box>

         </Box> 
      }

      {showEmailNotYetVerifiedMessage && 

        <Box>
          <Box
            sx={{
              mt: 4,
              p: 3,
              border: '1px solid #000000',
              borderRadius: '8px',
              textAlign: 'center',
              backgroundColor: '#f9f9f9',
            }}
          >
            <Typography variant="h6" gutterBottom color="blue">
              Email Not Verified
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Your email address has not been verified yet. Please check your inbox and follow the link in the verification email to activate your account.
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              If you haven’t received the email within 5 minutes, you can&nbsp;
              <Link href="#" onClick={handleResendVerificationEmail}>
                click here to resend it
              </Link>. Also, be sure to check your spam or junk folder just in case it ended up there.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCheckEmailHasBeenVerified}
            >
              I've Verified My Email <br></br> Continue to Application
            </Button>
          </Box>

          <Box
          sx={{paddingTop:'5px', textAlign:'center' }}
          >
          <Button
              variant="outlined"
              onClick={handleSignOutAndLogin}
              sx={{ textTransform: 'none' }}
            >
              Sign in as a different user
            </Button>
          </Box>

        </Box>
      }


      <Dialog open={openEmailAddressNotYetVerifiedDialog} onClose={handleCloseEmailAddressNotYetVerifiedDialog}>
          <DialogTitle>Email Has Not Been Verified</DialogTitle>
          <DialogContent>
            <DialogContentText>
            Your email has not been verified yet.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEmailAddressNotYetVerifiedDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog open={openEmailResentDialog} onClose={handleCloseEmailResentDialog}>
          <DialogTitle>Verification Email Resent</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Your verification email has been resent.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEmailResentDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openAcountHasEmailPasswordLoginDialog} onClose={() => setOpenAcountHasEmailPasswordLoginDialog(false)}>
          <DialogTitle>Email/Password Account Already Exists</DialogTitle>
          <DialogContent>
            <DialogContentText>
              This email is already registered with a password. Please sign in using your password or use the "Forgot your password?" link if you need to reset it.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => setOpenAcountHasEmailPasswordLoginDialog(false)}
              sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>



      <Dialog open={openAcountAlreadyExistsDialog} onClose={handleCloseAcountAlreadyExistsDialog}>
          <DialogTitle>Account Already Exists</DialogTitle>
          <DialogContent>
            <DialogContentText>
              An account with this email address already exists.<br></br><br></br>

              Please use a different email to sign up or click the 'Sign in' link below to log in. If you’ve forgotten your password, you can reset it there.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAcountAlreadyExistsDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>


        {/* Terms Dialog */}
        <Dialog open={openTermsDialog} onClose={handleCloseTermsDialog}>
          <DialogTitle>Terms of Service</DialogTitle>
          <DialogContent>
            <DialogContentText>
              You must agree to the Terms of Service before proceeding.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTermsDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      {/* End Terms Dialog */}

        </Box>
    </Container>
  );
};

export default Signup;
